import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import TravauxEnRegieComponent from '../../../components/Mouvement/Panel/TravauxEnRegieComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class TravauxEnRegiePanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.TRAVAUX_EN_REGIE;
		this.icon = { name: 'child' };
		this.defaultSize = 6;
	}

	getLibelle = () => 'Travaux en régie';

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find((ligne) => ligne?.cocheTravauxRegie);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
		_sens: string,
		...rest: any
	): React.ReactElement {
		return (
			<TravauxEnRegieComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
				{...rest}
			/>
		);
	};
}

export default TravauxEnRegiePanel;
